import {Form} from '@supermove/hooks';

export interface TagAssignmentFormType {
  tagAssignmentId?: string | number | null;
  tagIds: number[];
  jobId?: string | number | null;
  projectId?: string | number | null;
  callId?: number | null;
  isDeleted: boolean;
}

export type FormikTagAssignmentFormType = Form<{tagAssignmentForm: TagAssignmentFormType}>;

export interface TagAssignmentFormTypeAsMutation {
  tagAssignmentId?: string | number | null;
  tagIds: number[];
  jobId?: string | number | null;
  projectId?: string | number | null;
  callId?: number | null;
  isDeleted: boolean;
}

const _new = ({
  projectId,
  jobId,
  callId,
  tagIds,
}: {
  projectId?: string | number | null;
  jobId?: number | null | string;
  callId?: number | null;
  tagIds?: number[];
}): TagAssignmentFormType => ({
  tagAssignmentId: null,
  tagIds: tagIds || [],
  jobId,
  projectId,
  callId,
  isDeleted: false,
});

const _delete = ({
  tagAssignmentId,
  jobId,
  projectId,
  callId = null,
}: {
  tagAssignmentId: string | number;
  jobId?: string | number | null;
  projectId?: number | null;
  callId?: number | null;
}) => ({
  ..._new({}),
  tagAssignmentId,
  jobId,
  projectId,
  callId,
});

const toForm = (tagAssignmentForm: TagAssignmentFormType): TagAssignmentFormType => ({
  tagAssignmentId: tagAssignmentForm.tagAssignmentId,
  tagIds: tagAssignmentForm.tagIds,
  jobId: tagAssignmentForm.jobId,
  projectId: tagAssignmentForm.projectId,
  callId: tagAssignmentForm.callId,
  isDeleted: tagAssignmentForm.isDeleted,
});

const toMutation = (tagAssignmentForm: TagAssignmentFormType): TagAssignmentFormTypeAsMutation => ({
  tagAssignmentId: tagAssignmentForm.tagAssignmentId,
  tagIds: tagAssignmentForm.tagIds,
  jobId: tagAssignmentForm.jobId,
  projectId: tagAssignmentForm.projectId,
  callId: tagAssignmentForm.callId,
  isDeleted: tagAssignmentForm.isDeleted,
});

const TagAssignmentForm = {
  new: _new,
  delete: _delete,
  toForm,
  toMutation,
};

export default TagAssignmentForm;
